export var Orbit;
(function (Orbit) {
    Orbit["normal"] = "normal";
    Orbit["dynamic"] = "dynamic";
    Orbit["high"] = "high";
})(Orbit || (Orbit = {}));
//# sourceMappingURL=orbit.js.map